export const userConstants = {
  GET_ALL_DRIVERS: 'GET_ALL_DRIVERS',
  GET_ALL_USERS: 'GET_ALL_USERS',
  GET_ALL_RUSERS: 'GET_ALL_RUSERS',
  LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
  LOGOUT: 'USERS_LOGOUT',
}
